import script from "./CurrentAlarmsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentAlarmsCard.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentAlarmsCard.vue?vue&type=style&index=0&id=6a928fde&scoped=true&lang=css"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a928fde"]])

export default __exports__